import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchBy, selectItems } from '../../slice/itemSlice';
import magnifyingGlass from '../../assets/magnifying-glass.jpg'
import Banner from '../../components/Banner'
import { Container } from 'react-bootstrap';
import Items from './items/Items';
import Pagination from '../../components/Pagination'
import Newsletter from '../../components/newsletter/Newsletter'

const FilterPage = () => {
  const dispatch = useDispatch();
  const { name } = useParams();
  const items = useSelector(selectItems);

  useEffect(() => {
    dispatch(setSearchBy(name))
  }, [dispatch, name])

  return (<>
    <div className='page-wrapper bg-light'>
      <Banner img={magnifyingGlass}>
        <h1 className='display-5 '>Items You Searched For<span className='text-danger fw-bold'>.</span></h1>
      </Banner> 
      <Container>
        {
          items.length === 0 ? 
            <h2 className='w-100 text-center my-4 display-3'>No Item found<span className='text-danger'>!</span></h2>
            : 
            <><Pagination items={items} />  
            <Items />
            <Pagination items={items} /></>
        }  
        <Newsletter />
      </Container>
    </div>
  </>
  )
}

export default FilterPage